import { Cargo } from 'services/warehouse-containers/containers'
import { CargoItem } from './CargoItem/CargoItem'

import './item.style.css'

export type Props = {
  element: Cargo
  onSubmut: (cargo: Cargo) => void
  buttonText?: string
}

export const ContainerItem = ({ element, onSubmut, buttonText = 'Переместить' }: Props) => (
  <>
    <CargoItem element={element} buttonText={buttonText} onSubmut={onSubmut} />
  </>
)
